<template>
  <main class="max-w-5xl mx-auto px-16 md:px-24">
    <div
      class="py-24 border-b border-b-gray-200 flex justify-between items-end"
    >
      <Logo />
      <NuxtLink
        v-if="backUrl"
        :to="backUrl"
        class="font-bold leading-none text-sm md:text-base link"
      >
        {{ backText }}
      </NuxtLink>
    </div>
    <div v-if="title" class="mb-16 lg:mb-50">
      <ThankYouCheck v-if="isFinished" class="-mt-24 float-right w-[120px]" />
      <h1 class="typo-h2 mt-16 lg:mt-50" v-html="$sup(renderedTitle)" />
      <p
        v-if="lead"
        class="typo-lead-2 text-gray-400 mb-36"
        v-html="$sup(renderedLead)"
      />
    </div>

    <div v-if="isFinished">
      <slot name="finished">
        <div class="bg-white p-16 md:p-32 shadow-lg">
          <div class="ck-content">
            <p>
              Haben Sie Fragen? Wir stehen Ihnen gerne unter +41 52 635 22 22
              oder
              <a href="mailto:info@shkb.ch">info@shkb.ch</a> zur Verfügung.
            </p>
            <p>
              Freundliche Grüsse<br />
              Ihre Schaffhauser Kantonalbank
            </p>
          </div>
        </div>
      </slot>
    </div>

    <slot v-else />
  </main>
</template>

<script setup lang="ts">
import type {
  ConsultationWizardNodeFragment,
  ProductOrderFormDataNodeFragment,
} from '#graphql-operations'

const props = defineProps<{
  title?: string
  isFinished?: boolean
  lead?: string
  finishTitle?: string
  finishLead?: string
  node?: ProductOrderFormDataNodeFragment | ConsultationWizardNodeFragment
}>()

const data = await useInitData()
const { $sup } = useNuxtApp()

const renderedTitle = computed(() => {
  if (props.isFinished) {
    return props.finishTitle
  }
  return props.title
})

const renderedLead = computed(() => {
  if (props.isFinished) {
    return props.finishLead
  }

  return props.lead
})

const backText = computed(() => {
  if (props.node?.__typename === 'NodeService') {
    return 'Zurück zum Produkt'
  } else if (props.node?.__typename === 'NodePerson') {
    return 'Zurück zur Person'
  }

  return 'Zurück zur Seite'
})

const backUrl = computed(() => {
  if (props.node) {
    if (props.node?.__typename === 'NodePerson') {
      const anchorId = props.node.anchorId
      if (!anchorId) {
        return
      }

      if (!data.value.globalConfig.pagePeople) {
        return
      }

      return data.value.globalConfig.pagePeople + '#' + anchorId
    }
    return props.node?.url?.path
  }

  return '/'
})
</script>
